import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { toUnicode } from 'punycode';

@Injectable({ providedIn: 'root' })
@Pipe({
  standalone: true,
  name: 'email'
})
export class EmailPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return '';
    }
    return toUnicode(value);
  }
}
